<template>
  <div class="kpi-header">
    <!-- Left Section -->
    <div class="header-left">
      <div class="header-icon-wrapper">
        <ChartColumn class="header-icon" :size="24" />
      </div>
      <div class="header-info">
        <h2 class="header-title">{{ title }}</h2>
        <p class="header-subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <!-- Right Section -->
    <div class="header-actions">
      <!-- View Toggle -->
      <BFormRadioGroup  v-model="viewMode"
                        button-variant="outline-primary"
                        size="sm"
                        name="viewModeRadios"
                        :disabled="disabled"
                        buttons
                        @update:model-value="$emit('view-changed', $event)">
        <BFormRadio value="grid">
          <Grid3x3 :size="16" />
        </BFormRadio>
        <BFormRadio value="list">
          <List :size="16" />
        </BFormRadio>
      </BFormRadioGroup>

      <!-- Action Buttons -->
      <BButton class="action-btn"
              :disabled="disabled  || true"
              size="sm"
              variant="outline-primary"
              @click="$emit('config-click')">
        <Settings :size="16" />
        <span>{{ $t('Webportal.Configuration') }}</span>
      </BButton>

      <BButton class="action-btn"
              :disabled="disabled || true"
              size="sm"
              variant="primary"
              @click="$emit('add-click')">
        <Plus :size="16" />
        <span>{{ resolvedAddButtonText }}</span>
      </BButton>
    </div>
  </div>
</template>

<script>
import { ChartColumn, Grid3x3, List, Settings, Plus } from 'lucide-vue-next';

export default {
  name: 'KpiHeader',

  components: {
    ChartColumn,
    Grid3x3,
    List,
    Settings,
    Plus
  },

  data() {
    return {
      viewMode: 'grid'
    };
  },

  props: {
    title: { type: String, default: 'Meine KPI-Übersicht' },
    subtitle: { type: String, default: '' },
    addButtonText: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },

  emits: ['view-changed', 'config-click', 'add-click'],

  computed: {
    resolvedAddButtonText() {
      return this.addButtonText || this.$t('Webportal.Kpi.Add');
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon-wrapper {
  flex-shrink: 0;
}

.header-icon {
  color: var(--target-primary);
}

.header-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  // color: var(--target-primary);
  margin: 0;
}

.header-subtitle {
  font-size: 14px;
  color: var(--color-muted-foreground);
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 991px) {
    width: 100%;
    flex-wrap: wrap;
  }

  // Bootstrap button group styling
  :deep(.btn-group) {
    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8.5px 10px;

      // &.btn-primary {
      //   background: var(--target-primary);
      //   border-color: var(--target-primary);
      //   color: white;
      // }

      &.btn-outline-secondary {
        background: white;
        border-color: var(--color-border);
        color: var(--color-muted-foreground);

        &:hover {
          background: #f3f4f6;
          border-color: var(--color-border);
          color: #374151;
        }
      }
    }
  }
}

// .action-btn {
//   display: inline-flex;
//   align-items: center;
//   gap: 0.25rem;
//   border: 1px solid;
//   transition: all 0.15s ease;
//   white-space: nowrap;

//   &:hover {
//     box-shadow: 0 2px 4px var(--bmw-hover-border-color);
//   }
// }

// Dark Mode
:root.dark,
[data-bs-theme="dark"] {

  .header-subtitle {
    color: var(--color-muted-foreground);
  }

  // .header-actions {
  //   :deep(.btn-group) {
  //     .btn.btn-primary {
  //       background: var(--color-primary);
  //       border-color: var(--color-primary);
  //     }

  //     .btn.btn-outline-secondary {
  //       background: var(--color-card);
  //       border-color: var(--color-border);
  //       color: var(--color-muted-foreground);

  //       &:hover {
  //         background: var(--color-muted);
  //         color: var(--color-foreground);
  //       }
  //     }
  //   }
  // }

  // .action-btn-secondary {
  //   background: var(--color-card);
  //   color: var(--color-foreground);
  //   border-color: var(--color-border);

  //   &:hover {
  //     background: var(--color-muted);
  //   }
  // }
}
</style>
